__turbopack_context__.v({
  "notifications-button": "X4JvkG_notifications-button",
  "notifications-button--new": "X4JvkG_notifications-button--new",
  "notifications-button__icon-wrapper": "X4JvkG_notifications-button__icon-wrapper",
  "tindilin": "X4JvkG_tindilin",
});
